import {Component, OnInit} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {Router, RouterLink} from '@angular/router';
import {HomeService} from '../../services/home.service';
import {ToastService} from '../../services/toast.service';
import {FormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import {SubService} from 'src/app/services/sub.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    RouterLink,
    FormsModule,
    NgIf,
  ],
})
export class FooterComponent implements OnInit {
  appInitData;
  basketCount;

  constructor(private homeService: HomeService, private router: Router, private ts: ToastService, private sub: SubService) {
    this.sub.appInitData.subscribe((data) => {
        this.appInitData = data;
    });
    this.sub.isMobile.subscribe((data) => {
      this.isMobile = data;
    });
    this.sub.countCart.subscribe((data) => {
      this.basketCount = data;
    });
  }

  ngOnInit() {
  }

  email = '';
  email_error: any = null;
  newsletterLoader = false;
  isMobile;

  SaveNewsletter() {
    //check send email
    if (this.email === '' || !this.email) {
      this.email_error = 'Please enter your email';
      return;
    }

    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!pattern.test(this.email) && this.email !== '') {
      this.email_error = 'Invalid Email';
      return;
    }

    const fd = new FormData();
    fd.append('email', this.email);
    this.newsletterLoader = true;
    this.homeService.Newsletter(fd).subscribe((data) => {
      this.ts.SuccessToast('We will send you our latest news');
      this.newsletterLoader = false;
      this.email = '';
    }, error => {
      if (error.error.message === 'The email field is required') {
        this.ts.ErrorToast('Entered email is invalid');
      }
      if (error.error.message === 'email is invalid') {
        this.ts.ErrorToast('Entered email is invalid');
      }
      this.ts.ErrorToast('Something went wong');
      this.newsletterLoader = false;
    });
  }

  openProfile() {
    if (!this.appInitData) {
      this.sub.openAuth.next(true);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  redirectToBasket() {
    if (localStorage.getItem('cgi')) {
      this.router.navigate(['/basket/' + localStorage.getItem('cgi')]);
    } else {
      this.ts.ErrorToast('Empty Basket');
    }

  }


}
